import { splitEvery } from "rambdax"

// 购物loading显示
const list: any = splitEvery(2, new Array(6).fill(0))

export default function CardSkeleton() {
  return (
    <div>
      {list.map((v: any, i: any) => (
        <div className="cardBox" key={i}>
          {v.map((_n: any, m: any) => (
            <div className="box" key={m}>
              <div className="skeletonImg" />
              <div className="skeletonName" />
              <div className="skeletonModel" />
              <div className="skeletonPrice" />
            </div>
          ))}
        </div>
      ))}
      <style jsx>{`
        .skeleton {
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 112px;
          padding: 16px;
          background-color: #fff;
          border-radius: 10px;
          margin-bottom: 10px;
        }

        .skeletonCheck {
          flex: 0 0 auto;
          width: 21px;
          height: 21px;
          margin-right: 15px;
          border-radius: 50%;
        }

        .skeletonContent {
          flex: 1 1 auto;
          display: flex;
          flex-direction: row;
        }

        .skeletonImg {
          width: 100%;
          height: 136px;
          border-radius: 3px;
          margin-bottom: 10px;
          animation: skeleton-stripes 1s linear infinite;
        }

        .skeletonInfo {
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
          padding-left: 14px;
          padding-top: 7px;
        }

        .skeletonName {
          height: 14px;
          margin-bottom: 10px;
          width: 100px;
          animation: skeleton-stripes 1s linear infinite;
        }

        .skeletonModel {
          width: 80px;
          height: 12px;
          margin-bottom: 14px;
          animation: skeleton-stripes 1s linear infinite;
        }

        .skeletonPrice {
          width: 100px;
          height: 13px;
          animation: skeleton-stripes 1s linear infinite;
        }

        .skeletonBg {
          animation: skeleton-stripes 1s linear infinite;
        }

        .box {
          height: 241px;
          background: #ffffff;
          box-shadow: 0 1px 7px 3px rgba(184, 184, 184, 0.06);
          border-radius: 10px;
          width: calc((100vw - 42px) / 2);
          padding: 15px;
        }

        .cardBox {
          padding: 0 16px;
          padding-bottom: 10px;
          background-color: #f7f7f7;
          display: flex;
          justify-content: space-between;
        }

        @keyframes skeleton-stripes {
          0% {
            background: rgba(240, 240, 240, 0.6);
          }
          50% {
            background: rgba(240, 240, 240, 1);
          }
          to {
            background: rgba(240, 240, 240, 0.6);
          }
        }
      `}</style>
    </div>
  )
}
